export enum BulkProjectPlushieTypeValue {
  SAMPLE = "defa1e34-0800-4990-8b91-a3e83cf94672",
  BATCH = "cca05f29-bd12-4fd4-964c-ef14bb243cac",
}
